import {Component, OnInit, Input} from '@angular/core';

@Component({
    selector: 'app-view-task-timeline',
    templateUrl: './view-task-timeline.component.html',
    styleUrls: ['./view-task-timeline.component.css']
})
export class ViewTaskTimelineComponent implements OnInit {

    avatarWidth = '';

    @Input() comments: any;

    constructor() {
    }

    ngOnInit(): void {

    }

}
